import { useMemo } from 'react';
import { useItemsStore, useSearchStore } from '../store';
import { Category, Product } from '../interfaces/domain/menu';

export const useMenuPlates = () => {
  const menuDataCategories = useItemsStore(s => s.menuData?.categories);
  const query = useSearchStore(s => s.query);

  const hasFilter = query.trim().length > 0;

  const categoriesToDisplay = useMemo(() => {
    if (!menuDataCategories) return [];
    if (!hasFilter) return menuDataCategories;

    const lowerQuery = query.toLowerCase();

    // 🔥 función reusable (BIEN ubicada)
    const matches = (p: Product) =>
      p.title.toLowerCase().includes(lowerQuery) ||
      p.description?.toLowerCase().includes(lowerQuery) ||
      p.tags?.some(tag => tag.toLowerCase().includes(lowerQuery));

    return menuDataCategories
      .map((category: Category) => {
        const filteredProducts =
          category.products?.filter(matches) || [];

        const filteredSubcategories =
          category.subcategories
            ?.map(sub => ({
              ...sub,
              products: sub.products?.filter(matches) || []
            }))
            .filter(sub => sub.products.length > 0) || [];

        return {
          ...category,
          products: filteredProducts,
          subcategories: filteredSubcategories
        };
      })
      .filter(
        category =>
          category.products.length > 0 ||
          category.subcategories.length > 0
      );
  }, [query, menuDataCategories, hasFilter]);

  return {
    categoriesToDisplay,
    isEmpty: categoriesToDisplay.length === 0,
    hasFilter,
    query
  };
};